import {checkIfFlagIsToggled} from 'web-app/react/routes/debugger/local-storage-config';

export const MAX_FILE_SIZE = 10240e5;
export const MAX_IMAGE_SIZE = 200e3;
export const MAX_IMAGE_DIMENSION = 2560;

export const imageFileExtensions = () => {
    const supportHeic = checkIfFlagIsToggled('ENABLE_IMAGICK_IMAGE_PROCESSING');
    return ['.jpg', '.jpeg', '.png', '.gif', supportHeic ? '.heic' : null].filter(x => x);
};

export const videoFileExtensions = [
    '.mp4',
    '.mp4v',
    '.mpg4',
    '.3gp',
    '.3gp2',
    '.aac',
    '.flv',
    '.mpg',
    '.mpeg',
    '.mpe',
    '.m1v',
    '.ogg',
    '.wemb',
    '.avi',
    '.mkv',
    '.mov',
    '.qt',
    '.h261',
    '.h263',
    '.h264',
    '.ts',
];
export const documentFileExtensions = [
    '.txt',
    '.pdf',
    '.doc',
    '.docx',
    '.odt',
    '.ods',
    '.ppt',
    '.pptx',
    '.xls',
    '.xlsx',
    '.epub',
    '.csv',
    '.numbers',
    '.pages',
    '.key',
];

export const audioFileExtensions = [
    '.mp3', // MPEG-1 Audio Layer III – ubiquitous and highly compatible
    '.mpga', // MPEG-1 Audio Layer III – ubiquitous and highly compatible
    '.m4a', // AAC in an MPEG-4 container – common on Apple devices
    '.mp4a', // MPEG-4 Audio – common on Apple devices
];

export const USE_ANDROID_FOREGROUND_SERVICE_WHILE_USING_CAMERA_EXPERIMENT =
    'USE_ANDROID_FOREGROUND_SERVICE_WHILE_USING_CAMERA_EXPERIMENT';
